import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { SessionProvider } from './contexts/session-context';

// Fontsource imports - must be in JS for Vite to bundle font files
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/crimson-pro/400.css';
import '@fontsource/crimson-pro/500.css';
import '@fontsource/crimson-pro/600.css';
import '@fontsource/caveat/400.css';
import '@fontsource/dancing-script/400.css';
import '@fontsource/pacifico/400.css';
import '@fontsource/indie-flower/400.css';
import '@fontsource/homemade-apple/400.css';

import { router } from './router';
import './i18n/config';
import './app.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </StrictMode>
);
